import { useState } from "react";
import { getFeatures } from "../../../services/getFeatures";

interface Option {
  code: string | number;
  name: string;
  description: string;
}

const useFeaturesHandler = (
  rolePermissions: any[] | undefined | null,
  organizationLevelOptionSelected: number | undefined,
) => {
  const [hasLoadedFeatures, setHasLoadedFeatures] = useState<boolean>(false);
  const [featuresOptions, setFeaturesOptions] = useState<Option[]>([]);
  const [selectedPermissionOptions, setSelectedPermissionOptions] = useState<
    Option[]
  >([]);
  const [originalFeaturesDataTable, setOriginalFeaturesDataTable] = useState<
    any[]
  >([]);
  const [
    originalSelectedPermissionsDataTable,
    setOriginalSelectedPermissionsDataTable,
  ] = useState<any[]>([]);

  const getFeaturesOptions = async (organizationLevelOptionId: number) => {
    try {
      setHasLoadedFeatures(false);
      const result = await getFeatures(organizationLevelOptionId);
      if (
        rolePermissions &&
        organizationLevelOptionSelected === organizationLevelOptionId
      ) {
        const permissions = rolePermissions.map((code: string) => ({
          code,
          name:
            result.find((feature: any) => feature.code === code)?.name || "",
          description:
            result.find((feature: any) => feature.code === code)?.description ||
            "",
        }));

        setSelectedPermissionOptions(permissions);
        setOriginalSelectedPermissionsDataTable(permissions);

        const filteredFeaturesOptions = result.filter(
          (feature: any) =>
            !permissions.some(
              (permission: any) => permission.code === feature.code,
            ),
        );

        setFeaturesOptions(filteredFeaturesOptions);
        setOriginalFeaturesDataTable(filteredFeaturesOptions);
        setTimeout(() => {
          setHasLoadedFeatures(true);
        }, 1000);
      } else {
        setFeaturesOptions(result);
        setOriginalFeaturesDataTable(result);
        setTimeout(() => {
          setHasLoadedFeatures(true);
        }, 1000);
      }
    } catch (error) {
      console.log("API Error:", error);
    }
  };

  return {
    hasLoadedFeatures,
    featuresOptions,
    selectedPermissionOptions,
    originalFeaturesDataTable,
    originalSelectedPermissionsDataTable,
    setFeaturesOptions,
    setSelectedPermissionOptions,
    setOriginalFeaturesDataTable,
    setOriginalSelectedPermissionsDataTable,
    getFeaturesOptions,
  };
};

export default useFeaturesHandler;
